const OUTLOOK_WINDOW_FEATURES =
  "noopener,noreferrer,width=800,height=800,left=100,top=100";

const ensureSubjectPrefix = (subject, prefix) => {
  const value = subject || "";
  const pattern = new RegExp(`^${prefix}:\\s*`, "i");
  return pattern.test(value) ? value : `${prefix}: ${value}`.trim();
};

const normalizePlainText = (text = "") =>
  text
    .replace(/\u00a0/g, " ")
    .replace(/\r\n/g, "\n")
    .split("\n")
    .map((line) => line.trim())
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

const getPlainBody = (emailInfo = {}) => {
  if (emailInfo.isHtmlBody && emailInfo.htmlBody) {
    const container = document.createElement("div");
    container.innerHTML = emailInfo.htmlBody;
    container.querySelectorAll("script, style, img").forEach((node) => node.remove());
    return normalizePlainText(container.innerText || container.textContent || "");
  }

  return normalizePlainText(emailInfo.body || "");
};

const buildQuotedBody = (emailInfo = {}) => {
  const from = emailInfo.fromRecipient?.emailAddress || "";
  const to = (emailInfo.toRecipients || [])
    .map((recipient) => recipient?.emailAddress)
    .filter(Boolean)
    .join(",");
  const sent = emailInfo.date
    ? new Date(emailInfo.date).toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
    : "";

  const quoteHeader = [
    "----- Original Message -----",
    `From: ${from}`,
    `Sent: ${sent}`,
    `To: ${to}`,
    `Subject: ${emailInfo.subject || ""}`,
  ].join("\n");

  const body = getPlainBody(emailInfo);
  return body ? `${quoteHeader}\n\n${body}` : quoteHeader;
};

export const buildEmailComposeData = (emailInfo = {}, action) => ({
  to: action === "reply" ? emailInfo.fromRecipient?.emailAddress || "" : "",
  subject: ensureSubjectPrefix(
    emailInfo.subject || "",
    action === "reply" ? "Re" : "FW"
  ),
  body: buildQuotedBody(emailInfo),
});

export const openOutlookCompose = ({ to, subject, body }) => {
  const url = `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(
    to || ""
  )}&subject=${encodeURIComponent(subject || "")}&body=${encodeURIComponent(body || "")}`;

  window.open(url, "_blank", OUTLOOK_WINDOW_FEATURES);
};
